import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { FormButtonSettingsData } from '@sites/entity-core';
import type { FormWidgetForm } from '@sites/entity-signal-form';

import { CommonElementsModule } from '@web/widgets/common/common-elements.module';
import { SpFormButtonSettingsSignalComponent } from '@components/sp-form-button-settings-signal';
import { isEmptyButtonLabel } from '@common/helpers';

import { FormSettingsPanel } from '@web/widgets/common/abstract/form-settings-panel';

/**
 * Breadcrumbs/footer chrome around `sp-form-button-settings-signal`, writing
 * straight into the widget signal form. The `isModalButton` input picks which
 * of the two button-settings branches (`formButtonSettings` vs
 * `modalFormButtonSettings`) is edited. Save/cancel and the transaction frame
 * come from `FormSettingsPanel`.
 */
@Component({
    selector: 'web-form-button-settings',
    templateUrl: './form-button-settings.component.html',
    styleUrls: ['./form-button-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule, SpFormButtonSettingsSignalComponent],
})
export class FormButtonSettingsComponent extends FormSettingsPanel<FormWidgetForm> {
    public readonly isModalButton = input<boolean>(false);
    public readonly isHorizontalForm = input<boolean>(false);

    public readonly settings = computed<FormButtonSettingsData>(() =>
        this.isModalButton() ? this.form().modalFormButtonSettings().value() : this.form().formButtonSettings().value()
    );

    public onSettingsChange(value: FormButtonSettingsData): void {
        if (this.isModalButton()) {
            this.form().setModalFormButtonSettings(value);
        } else {
            this.form().setFormButtonSettings(value);
        }
    }

    public override get saveDisablePredicate(): boolean {
        return isEmptyButtonLabel(this.settings().label);
    }
}
